import React from "react";
import { SectionHeader } from "../components/section-header";
import { SponsoredContent } from "@/components/features/advertisement/sponsored-content";

interface SponsoredContentSectionProps {
  items: any[];
}

export function SponsoredContentSection({ items }: SponsoredContentSectionProps) {
  if (items.length === 0) return null;

  return (
    <section className="border-b border-border bg-neutral-50/50" aria-labelledby="sponsored-heading">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <SectionHeader
          eyebrow="Sponsored"
          title="Partner Resources"
        />
        <div className="grid gap-4 md:grid-cols-2">
          {items.map((item: any) => (
            <SponsoredContent
              key={item.id}
              title={item.title}
              description={item.content}
              sponsorName={item.author ?? "HRShakti Partners"}
              href={`/news/${item.id}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}